import React from 'react'
import { Tooltip, Box } from '@mui/material'
import { HelpCircle } from 'lucide-react'

interface InfoTooltipProps {
  text: string
  size?: number
}

export default function InfoTooltip({ text, size = 14 }: InfoTooltipProps): JSX.Element {
  return (
    <Tooltip
      title={text}
      arrow
      placement="top"
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: 'rgba(15, 23, 42, 0.95)',
            backdropFilter: 'blur(12px)',
            border: '1px solid rgba(168, 85, 247, 0.2)',
            borderRadius: '8px',
            color: 'rgba(255,255,255,0.85)',
            fontSize: '12px',
            lineHeight: 1.5,
            padding: '8px 12px',
            maxWidth: 280,
          },
        },
        arrow: {
          sx: {
            color: 'rgba(15, 23, 42, 0.95)',
          },
        },
      }}
    >
      <Box component="span" sx={{ display: 'inline-flex', cursor: 'help', ml: 0.5, opacity: 0.4, '&:hover': { opacity: 0.8 } }}>
        <HelpCircle size={size} />
      </Box>
    </Tooltip>
  )
}
